const JsSiteHeader = {
	init () {

		/*              __
		               / _)         
		        .-^^^-/ /          
		    __/       /              
		    <__.|_|-|_|  

		    The Emagine Dinosaur says that searching is fun, go search some stuff.           
		*/

		/*
		* Expandable Search Input (Medium up)
		*/
		
		if ( $('.c-site-header-search-and-langs').length ) {

			$('.c-site-header-search-and-langs').find('.search-form').submit(function(e){
				e.preventDefault(); 

				// Show / Hide the search input
				if ( !$(this).hasClass('active') ) {
					$(this).addClass('active');
				} else {
					$(this).removeClass('active');
				}

				// Check to see if any search input has been added
				let searchTarget = $(this).find('.search-input').val();

				// Let search button submit search
				if ( searchTarget !== '' ) {
					this.submit();
				}
			});

		}

	}
};

export default JsSiteHeader;


// WEBPACK FOOTER //
// ./src/components/03-ui/site-header/site-header.js